import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, Check } from 'lucide-react';

const CTABanner = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-gradient-to-r from-[#EB2F5B] to-[#d02850] py-20 px-6">
      <div className="max-w-4xl mx-auto text-center text-white">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Ready to Transform Your Email Signatures?
        </h2>
        <p className="text-xl mb-10 opacity-90">
          Join 1,000+ companies using SlickSignature to create professional, on-brand signatures
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Button
            onClick={() => navigate('/checkout?plan=business')}
            size="lg"
            className="bg-white text-[#EB2F5B] hover:bg-gray-100 text-lg px-8 py-6"
          >
            Start Your Free 15-Day Trial
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <Button
            onClick={() => window.location.href = 'mailto:support@slicksignature.com'}
            size="lg"
            variant="outline"
            className="border-2 border-white text-white hover:bg-white hover:text-[#EB2F5B] text-lg px-8 py-6"
          >
            Talk to Sales
          </Button>
        </div>
        <div className="flex flex-wrap justify-center gap-6 text-base">
          <div className="flex items-center">
            <Check className="h-5 w-5 mr-2" strokeWidth={3} />
            <span>Setup in 5 minutes</span>
          </div>
          <div className="flex items-center">
            <Check className="h-5 w-5 mr-2" strokeWidth={3} />
            <span>Cancel anytime</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
